import { db } from '../config/firebase';
import { collection, getDocs, query, orderBy, where, doc, getDoc } from 'firebase/firestore';

export const courseService = {
  // Get all published courses (for regular users)
  getAllCourses: async () => {
    try {
      const coursesRef = collection(db, 'courses');
      const coursesQuery = query(coursesRef, orderBy('order', 'asc'));
      const coursesSnap = await getDocs(coursesQuery);
      const courses = [];
      
      coursesSnap.forEach((doc) => {
        courses.push({
          id: doc.id,
          ...doc.data(),
        });
      });
      
      return { courses, error: null };
    } catch (error) {
      console.error('Error fetching courses:', error);
      return { courses: [], error: error.message };
    }
  },

  // Get only available courses
  getAvailableCourses: async () => {
    try {
      const coursesRef = collection(db, 'courses');
      const coursesQuery = query(
        coursesRef, 
        where('status', '==', 'Available'),
        orderBy('order', 'asc')
      );
      const coursesSnap = await getDocs(coursesQuery);
      const courses = [];
      
      coursesSnap.forEach((doc) => {
        courses.push({
          id: doc.id,
          ...doc.data(),
        });
      });
      
      return { courses, error: null };
    } catch (error) {
      console.error('Error fetching available courses:', error);
      return { courses: [], error: error.message };
    }
  },

  // Get a single course by ID
  getCourseById: async (courseId) => {
    try {
      const courseRef = doc(db, 'courses', courseId);
      const courseSnap = await getDoc(courseRef);
      
      if (!courseSnap.exists()) {
        return { course: null, error: 'Course not found' };
      }
      
      return { 
        course: {
          id: courseSnap.id,
          ...courseSnap.data(),
        }, 
        error: null 
      };
    } catch (error) {
      console.error('Error fetching course:', error);
      return { course: null, error: error.message };
    }
  },
};

